<template>
  <div v-if="geofence.geo_fences && geofence.geo_lines && geofence.geo_points">
    <div class="text-nowrap" :id="'tooltip-relationships-geofences-' + rnd" v-translate="{count: geofence.geo_fences.length}">GeoFences: <strong>%{count}</strong></div>
    <div class="text-nowrap" :id="'tooltip-relationships-geolines-' + rnd" v-translate="{count: geofence.geo_lines.length}">GeoLines: <strong>%{count}</strong></div>
    <div class="text-nowrap" :id="'tooltip-relationships-geopoints-' + rnd" v-translate="{count: geofence.geo_points.length}">GeoPoints: <strong>%{count}</strong></div>
    <b-tooltip :target="'tooltip-relationships-geofences-' + rnd" triggers="hover" custom-class="tooltip-w350" v-if="geofence.geo_fences.length > 0">
      <ul class="text-left ml-2 mb-0 pl-2">
        <li v-for="(element, index) in geofence.geo_fences" :key="'geofences' + rnd + index"><strong>{{element.external_id}}</strong> {{ element.name }} <small>[{{ element.geo_type.name }}]</small></li>
      </ul>
    </b-tooltip>
    <b-tooltip :target="'tooltip-relationships-geolines-' + rnd" triggers="hover" custom-class="tooltip-w350" v-if="geofence.geo_lines.length > 0">
      <ul class="text-left ml-2 mb-0 pl-2">
        <li v-for="(element, index) in geofence.geo_lines" :key="'geolines' + rnd + index"><strong>{{element.external_id}}</strong> {{ element.name }} <small>[{{ element.geo_type.name }}]</small></li>
      </ul>
    </b-tooltip>
    <b-tooltip :target="'tooltip-relationships-geopoints-' + rnd" triggers="hover" custom-class="tooltip-w350" v-if="geofence.geo_points.length > 0">
      <ul class="text-left ml-2 mb-0 pl-2">
        <li v-for="(element, index) in geofence.geo_points" :key="'geopoints' + rnd + index"><strong>{{element.external_id}}</strong> {{ element.name }} <small>[{{ element.geo_type.name }}]</small></li>
      </ul>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ListItemRelationships',
  props: {
    geofence: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rnd: Math.random()
    }
  }
}
</script>

<style lang="scss">
.tooltip-w350 {
  .tooltip-inner {
    max-width: 350px !important;

  }
}
</style>
